import { render, staticRenderFns } from "./SkinThickness.vue?vue&type=template&id=1beed804"
import script from "./SkinThickness.vue?vue&type=script&lang=js"
export * from "./SkinThickness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports